<template>
  <div class="tab-content" :class="(!applyStatus.page.tab05.enable)?'app-lock':''">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      :show-message="false"
      :hide-required-asterisk="true"
    >
      <el-form-item label="temp" prop="apkFile">
        <template slot="label">
          <label for>{{t_content('botApp.tab05.apkFile')}}</label>
          <span class="hint">{{t_content('botApp.tab05.apkFile.hint')}}</span>
        </template>
        <el-row>
          <el-col :span="12">
            <file-info-pad
              v-if="hasAPK()"
              :fileInfo="form.apkFile"
              ref="tab05_part1"
              @apkdelete="apkdelete"
            />
          </el-col>
          <el-col :span="hasAPK()?12:24">
            <el-upload
              class="upload-demo"
              drag
              :action="uploadActionUrl"
              :on-success="handleOK"
              :on-error="handleError"
              :headers="headers"
              name="uploadFile"
              accept=".apk, .mbt"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or
                <em>click to upload</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
            </el-upload>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="temp" v-if="!isfree">
        <template slot="label">
          <label>{{t_content('botApp.tab05.previewApkFile') + '('+ $t('botApp.tab05.optional') +')'}}</label>
        </template>
        <el-row>
          <el-col :span="12">
            <file-info-pad
              v-if="hasAPK_preview()"
              :fileInfo="form.previewApkFile"
              ref="tab05_part2"
              @apkdelete="apkdelete"
            />
          </el-col>
          <el-col :span="hasAPK_preview()?12:24">
            <el-upload
              class="upload-demo"
              drag
              :action="uploadActionUrl"
              :on-success="handleOK_preview"
              :on-error="handleError"
              :headers="headers"
              name="uploadFile"
              accept=".apk, .mbt"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or
                <em>click to upload</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
            </el-upload>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="temp" prop="supportLangs">
        <template slot="label">
          <label>{{t_content('botApp.tab05.supportLangs')}}</label>
        </template>
        <el-select
          v-model="form.supportLangs"
          multiple
          filterable
          default-first-option
          placeholder="Choose tags for your article"
        >
          <el-option
            v-for="item in langOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="temp" prop="releaseNote">
        <template slot="label">
          <label>{{t_content('botApp.tab05.releaseNote')}}</label>
        </template>
        <el-input type="textarea" v-model="form.releaseNote"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="testInstruction">
        <template slot="label">
          <label>{{t_content('botApp.tab05.testInstruction')}}</label>
        </template>
        <el-input type="textarea" v-model="form.testInstruction"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="isAcceptExportLaw">
        <template slot="label">
          <label>{{t_content('botApp.tab05.exportLaw')}}</label>
        </template>
        <el-checkbox v-model="exportLaw"></el-checkbox>&nbsp;&nbsp;
        <span>{{t_content('botApp.tab05.exportLawDesc')}}</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../../api'
import apiConfig, { apiFileApkConfig } from '../../../api/apiConfig'
import _ from 'lodash'
import FileInfoPad from './tab05/fileInfoPad'
export default {
    mounted () {
        let vm = this
        vm.$root.$on('isFreeChanged', data => {
            vm.isFree = data
        })
        this.pubLang()
    },
    data () {
        const {
            downloadUrl,
            previewDownloadUrl,
            supportLangs,
            releaseNote,
            testInstruction,
            isFree,
            isAcceptExportLaw,
            contentExtra
        } = this.appInfo

        const packageStr = this.appInfo.package

        let apkFile = null
        let previewApkFile = null

        if (contentExtra) {
            if (contentExtra.objectKey) {
                apkFile = {
                    objectKey: contentExtra.objectKey,
                    package: contentExtra.package || packageStr,
                    versionCode: contentExtra.versionCode,
                    versionName: contentExtra.versionName,
                    size: contentExtra.size
                }
            }
            if (contentExtra.previewObjectKey) {
                previewApkFile = {
                    objectKey: contentExtra.previewObjectKey,
                    package: contentExtra.package,
                    versionCode: contentExtra.previewVersionCode,
                    versionName: contentExtra.previewVersionName,
                    size: contentExtra.previewSize
                }
            }
        }
        var requiredChk = (rule, value, callback, label) => {
            let vm = this
            if (value !== 'Y') {
                const errMsg =
                    label + ' ' + this.t_content('botApp.common.valid.required')
                vm.$store.state.botAppErrMessages.push(errMsg)
                callback(new Error('Please input the data'))
            } else {
                callback()
            }
        }
        var required = (rule, value, callback, label) => {
            let vm = this
            if (value === null) {
                const errMsg =
                    label + ' ' + this.t_content('botApp.common.valid.required')
                vm.$store.state.botAppErrMessages.push(errMsg)
                callback(new Error('Please input the data'))
            } else {
                callback()
            }
        }

        return {
            form: {
                apkFile,
                previewApkFile,
                downloadUrl,
                previewDownloadUrl,
                supportLangs,
                releaseNote,
                testInstruction,
                isAcceptExportLaw
            },
            // exportLaw: false,
            uploadActionUrl: apiFileApkConfig(),

            langOptions: [],
            // apkUploaded: false,
            // apkUploaded_preview: false,
            isFree,
            // fileInfo: null,
            // fileInfo_preview: null,
            rules: {
                apkFile: [
                    {
                        validator: (rule, value, callback) =>
                            required(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab05.apkFile')
                            ),
                        trigger: 'blur'
                    }
                ],
                supportLangs: [{ required: true, trigger: 'blur' }],
                releaseNote: [{ required: true, trigger: 'blur' }],
                testInstruction: [{ required: true, trigger: 'blur' }],
                isAcceptExportLaw: [
                    {
                        validator: (rule, value, callback) =>
                            requiredChk(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab05.exportLaw')
                            ),
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    props: ['appInfo', 'applyStatus'],
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        apkdelete (value) {
            this.$confirm(
                this.t_content('botApp.common.delete.dialog.msg'),
                this.t_content('botApp.common.delete.dialog.title'),
                {
                    confirmButtonText: this.t_content('botApp.common.delete.dialog.ok'),
                    cancelButtonText: this.t_content('botApp.common.delete.dialog.cancel'),
                    type: 'warning'
                }
            )
                .then(() => {
                    if (this.form.downloadUrl === value) {
                        this.form.downloadUrl = ''
                        this.form.apkFile = null
                    }
                    if (this.form.previewDownloadUrl === value) {
                        this.form.previewDownloadUrl = ''
                        this.form.previewApkFile = null
                    }
                })
                .catch(() => {
                })
        },
        getDataFromChild () {
            this.form.contentExtra = null
            this.form.downloadUrl = ''
            this.form.previewDownloadUrl = ''

            // apk1
            if (this.form.apkFile) {
                let partIfileInfo = this.$refs.tab05_part1.getDataFromChild()
                if (this.form.contentExtra === null) {
                    this.form.contentExtra = {}
                }
                this.form.contentExtra.size = partIfileInfo.size
                this.form.contentExtra.versionCode =
                    partIfileInfo.versionCode // zevi
                this.form.contentExtra.versionName = partIfileInfo.versionName

                this.form.downloadUrl = partIfileInfo.objectKey
            }
            // apk2
            if (this.form.previewApkFile) {
                let partIIfileInfo = this.$refs.tab05_part2.getDataFromChild()
                if (this.form.contentExtra === null) {
                    this.form.contentExtra = {}
                }
                this.form.contentExtra.previewSize = partIIfileInfo.size
                this.form.contentExtra.previewVersionCode =
                    partIIfileInfo.versionCode
                this.form.contentExtra.previewVersionName =
                    partIIfileInfo.versionName

                this.form.previewDownloadUrl = partIIfileInfo.objectKey
            }
            if (this.form.contentExtra) {
                // delete this.form.contentExtra.objectKey
                // delete this.form.contentExtra.package
                // delete this.form.contentExtra.previewObjectKey
            }

            return this.form
        },
        handleOK (resp) {
            this.form.apkFile = { ...resp.data }
            // this.apkUploaded = true
        },
        handleError () {
            alert('error')
        },
        handleOK_preview (resp) {
            this.form.previewApkFile = { ...resp.data }
            // this.apkUploaded_preview = true
        },
        hasAPK () {
            return !!this.form.apkFile
        },
        hasAPK_preview () {
            return !!this.form.previewApkFile
        },

        pubLang () {
            // const { title, message, status, publishAfterDate } = this
            const apiUri = 'developer/lang'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    this.langOptions = response.data.data.payload
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    components: {
        'file-info-pad': FileInfoPad
    },
    computed: {
        langOption () {
            let opts = _.map(this.langOptions, n => {
                return {
                    value: n.name,
                    label: n.name
                }
            })

            return _.filter(opts, o => {
                return this.form.supportLangs.indexOf(o.value) === -1
            })
        },
        headers () {
            return apiConfig('').headers
        },
        isfree () {
            return this.isFree === 'Y'
        },
        exportLaw: {
            get () {
                return this.form.isAcceptExportLaw === 'Y'
            },
            set (value) {
                this.form.isAcceptExportLaw = value ? 'Y' : 'N'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.el-col-12 {
    padding: 5px;
}
.el-select {
    width: 100%;
}
</style>
